import { cn } from '@/lib/utils'
import { ARTIFACTS_LABEL } from './accountModel'
import { AGENT_FACES, DEFAULT_FACE } from './agentFaces'
import { AgentNameProvider } from './agentName'
import caiAdMvp from './caiAdMvp.webp'
import { AGENT_NAME, MVP_TAB_DETAIL, MVP_TAB_LABELS, MVP_TAB_PAGES, MVP_TABS } from './caiMvp'
import { DESKTOP_WIDTH, MOBILE_WIDTH, OptionSection } from './OptionSection'
import { PlainMobilePlacement } from './PlainMobilePlacement'
import { ProductOnboardingDesktop } from './ProductOnboardingDesktop'
import { TrialNotice } from './TrialNotice'

/** What ships first, and the pitch that goes with it. */
export function CaiMvpPositioningSection({ shellClass }: { shellClass: string }) {
  return (
    <AgentNameProvider
      name={AGENT_NAME}
      face={DEFAULT_FACE}
      faceOptions={AGENT_FACES}
      artifactsLabel={ARTIFACTS_LABEL}
    >
      <OptionSection
        title="Cai MVP positioning"
        defaultOpen
        panes={[
          {
            label: 'Ad',
            width: 310,
            hideWidth: true,
            content: (
              <div className={cn('flex flex-col', shellClass)}>
                <img
                  src={caiAdMvp}
                  alt="Cai watches the money, you watch the road. The first AI for fleet owners."
                  className="w-full object-contain"
                />
              </div>
            ),
          },
          {
            label: 'Desktop',
            width: DESKTOP_WIDTH,
            content: (
              <ProductOnboardingDesktop
                className={shellClass}
                tabs={MVP_TABS}
                tabLabels={MVP_TAB_LABELS}
                tabDetail={MVP_TAB_DETAIL}
                tabPages={MVP_TAB_PAGES}
                composerFooter={<TrialNotice />}
                softComposer
                chromeTint
                handoff
              />
            ),
          },
          {
            label: 'Mobile web',
            width: MOBILE_WIDTH,
            content: (
              <PlainMobilePlacement className={shellClass} tabs={MVP_TABS} tabLabels={MVP_TAB_LABELS} />
            ),
          },
        ]}
      />
    </AgentNameProvider>
  )
}
